var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "normal-page",
          attrs: { "body-style": { padding: "0px 20px 20px 20px" } },
        },
        [
          _c("formBox", {
            attrs: {
              total: _vm.total,
              info: _vm.info,
              type: "module",
              keyName: _vm.keyName,
            },
            on: {
              getInfo: _vm.getInfo,
              getList: _vm.getList,
              confirmData: _vm.confirmData,
              addData: _vm.addData,
              handleDelete: _vm.handleDelete,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "table-box mt10",
            },
            [
              _c(
                "el-table",
                {
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    height: _vm.tableHeight,
                    "row-key": "id",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      "min-width": "55",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.info.showField, function (item, index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: item.field_name_en,
                        label: item.field_name,
                        width: [
                          "input_percentage",
                          "tag",
                          "image",
                          "textarea",
                          "checkbox",
                          "date_picker",
                          "date_time_picker",
                          "cascader",
                          "cascader_address",
                        ].includes(item.form_value)
                          ? 200
                          : "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                item.form_value === "image"
                                  ? _c(
                                      "div",
                                      { staticClass: "img-box" },
                                      [
                                        _vm._l(
                                          scope.row[item.field_name_en],
                                          function (val, index) {
                                            return _c("img", {
                                              key: index,
                                              staticClass: "img",
                                              attrs: { src: val.url, alt: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.lookViewer(
                                                    val.url,
                                                    val.name
                                                  )
                                                },
                                              },
                                            })
                                          }
                                        ),
                                        _vm._v(" "),
                                        !scope.row[item.field_name_en] ||
                                        scope.row[item.field_name_en].length ==
                                          0
                                          ? _c("span", [_vm._v("--")])
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : item.form_value === "file"
                                  ? _c(
                                      "div",
                                      [
                                        _vm.normalizeCrudFiles(
                                          scope.row[item.field_name_en]
                                        ).length
                                          ? _vm._l(
                                              _vm.normalizeCrudFiles(
                                                scope.row[item.field_name_en]
                                              ),
                                              function (val, fIdx) {
                                                return _c(
                                                  "el-button",
                                                  {
                                                    key: "f_" + fIdx,
                                                    staticClass:
                                                      "file-down-btn",
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.downloadCrudFile(
                                                          val
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("下载文件")]
                                                )
                                              }
                                            )
                                          : _c("span", [_vm._v("--")]),
                                      ],
                                      2
                                    )
                                  : item.form_value === "input_percentage"
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-progress", {
                                          attrs: {
                                            percentage: scope.row[
                                              item.field_name_en
                                            ]
                                              ? scope.row[item.field_name_en]
                                              : 0,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : item.form_value === "tag" ||
                                    item.form_value === "checkbox"
                                  ? _c(
                                      "div",
                                      [
                                        scope.row[item.field_name_en] &&
                                        scope.row[item.field_name_en].length > 2
                                          ? _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top-start",
                                                  trigger: "hover",
                                                },
                                              },
                                              [
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex_box" },
                                                    _vm._l(
                                                      scope.row[
                                                        item.field_name_en
                                                      ],
                                                      function (val, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass: "tips",
                                                          },
                                                          [
                                                            _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  size: "small",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      val
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "flex_box",
                                                      },
                                                      [
                                                        _vm._l(
                                                          scope.row[
                                                            item.field_name_en
                                                          ],
                                                          function (
                                                            val,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "tips",
                                                              },
                                                              [
                                                                index < 2
                                                                  ? _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size: "small",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                        " +
                                                                            _vm._s(
                                                                              val
                                                                            ) +
                                                                            "\n                      "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        scope.row[
                                                          item.field_name_en
                                                        ] &&
                                                        scope.row[
                                                          item.field_name_en
                                                        ].length > 2
                                                          ? _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  size: "small",
                                                                },
                                                              },
                                                              [_vm._v("...")]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "flex_box" },
                                                [
                                                  _vm._l(
                                                    scope.row[
                                                      item.field_name_en
                                                    ],
                                                    function (val, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass: "tips",
                                                        },
                                                        [
                                                          index < 2
                                                            ? _c(
                                                                "el-tag",
                                                                {
                                                                  attrs: {
                                                                    size: "small",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        val
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  scope.row[
                                                    item.field_name_en
                                                  ] &&
                                                  scope.row[item.field_name_en]
                                                    .length > 2
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            size: "small",
                                                          },
                                                        },
                                                        [_vm._v("...")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ],
                                        _vm._v(" "),
                                        !scope.row[item.field_name_en] ||
                                        scope.row[item.field_name_en].length ==
                                          0
                                          ? _c("span", [_vm._v("--")])
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : item.form_value === "switch"
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-switch", {
                                          attrs: {
                                            disabled: "",
                                            "active-value": 1,
                                            "inactive-value": 0,
                                            "active-text": "开启",
                                            "inactive-text": "关闭",
                                          },
                                          model: {
                                            value:
                                              scope.row[item.field_name_en],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                item.field_name_en,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row[item.field_name_en]",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : item.form_value === "textarea"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top-start",
                                              width: "350",
                                              trigger: "hover",
                                              content:
                                                scope.row[item.field_name_en],
                                            },
                                          },
                                          [
                                            scope.row[item.field_name_en] &&
                                            scope.row[item.field_name_en]
                                              .length > 11
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "over-text",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          scope.row[
                                                            item.field_name_en
                                                          ]
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row[item.field_name_en] &&
                                        scope.row[item.field_name_en].length <=
                                          11
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    scope.row[
                                                      item.field_name_en
                                                    ]
                                                  ) +
                                                  "\n              "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !scope.row[item.field_name_en]
                                          ? _c("span", [_vm._v("--")])
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : [
                                      "input_number",
                                      "input_float",
                                      "input_price",
                                    ].includes(item.form_value)
                                  ? _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[item.field_name_en]
                                          ) +
                                          "\n            "
                                      ),
                                    ])
                                  : _c("div", [
                                      item.field_name_en ==
                                      _vm.info.crudInfo.main_field_name
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "color-doc pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.checkRow(scope.row)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getValue(
                                                      scope.row[
                                                        item.field_name_en
                                                      ]
                                                    )
                                                  )
                                              ),
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getValue(
                                                    scope.row[
                                                      item.field_name_en
                                                    ]
                                                  )
                                                )
                                            ),
                                          ]),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "address",
                      label: "操作",
                      fixed: "right",
                      width: "170",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.checkRow(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editRow(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteRow(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-size": _vm.where.limit,
                      "current-page": _vm.where.page,
                      "page-sizes": [15, 20, 30],
                      layout: "total,sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
      _vm._v(" "),
      _vm.addDrawerShow
        ? _c("add-drawer", {
            ref: "addDrawer",
            attrs: { keyName: _vm.keyName },
            on: { getList: _vm.getList },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.checkDrawerShow
        ? _c("check-drawer", {
            ref: "checkDrawer",
            attrs: { keyName: _vm.keyName, info: _vm.info },
            on: { getList: _vm.getList, getInfo: _vm.getInfo },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }